<template>
  <v-dialog v-model="deleteShareGroupDialogVisible" width="700">
    <customDialog>
      <template v-slot:title>
        {{ts('privilegeDeleteMessage')}}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img"
						@click="deleteShareGroupDialogVisible = false">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0 pt-15" justify="center">
          <v-col class="ma-0 pa-0" cols="10" align="center">
            <v-row class="ma-0 pa-0 pb-2" align="center" justify="center">
              <v-btn class="ma-0 pa-0 mr-3" id="grey_btn" @click="deleteShareGroupDialogVisible = false"
                width="8rem" height="2rem">
									{{t('cancel')}}
							</v-btn>
              <v-btn class="ma-0 pa-0" id="blue_btn" @click="deleteShareGroup"
                width="8rem" height="2rem">{{t('decision')}}</v-btn>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </customDialog>
  </v-dialog>
</template>
<script>
import mixin from '@/mixin';
import customDialog from '@/components/Modal.vue';
export default {
	props: {
		dialogVisible: Boolean,
    deleteGroupId: String,
	},
	components: {
		customDialog
	},
	mixins: [mixin.common],
	data: () => ({
    deleteShareGroupDialogVisible: false,
    isDeleted: false,
  }),
  watch: {
		dialogVisible: function(item) {
			this.deleteShareGroupDialogVisible = item;
		},
    deleteShareGroupDialogVisible: function(item) {
      this.$emit('visible', item);
      this.$emit('isDeleted', this.isDeleted);
    }
  },
  mounted() {
  },
  methods: { 
		ts(t) {
      return this.$t("lang.settings." + t);
    },
    async deleteShareGroup() {
      let params = {};
      let id = this.deleteGroupId;
      await this.networkController.deleteUserGroupAuthGroup(params, id)
      .then(async(res) => {
				this.showToastMessage(this.tmb('requestSuccess'));
        this.isDeleted = true;
        this.deleteShareGroupDialogVisible = false;
      }).catch(error => {
				this.showToastMessage(this.tmb('requestFail'));
        this.isDeleted = false;
        this.deleteShareGroupDialogVisible = false;
      });
    }
  }
}
</script>
<style lang="scss" scoped>
</style>